module.exports = __webpack_public_path__ + "static/img/light.40f88c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/light.png
// module id = IRCO
// module chunks = 7